import { css } from '@emotion/core';
import { variables, media, rgba } from '@domain-group/fe-brary';
var colour = variables.colour;
var navigationArrowColour = colour.white;
var gradientStart = rgba(colour.black, 0);
var gradientEnd = rgba(colour.black, 0.4);
var hoverGradientStart = rgba(colour.black, 0.1);
var hoverGradientEnd = rgba(colour.black, 0.5);
var navButtonWidth = 88;
var _ref = {
  name: "e8rb6x",
  styles: "text-align:left;&:hover{.fe-co-allhomes-hero-photo-preview__gradient.is-left{opacity:0;}.fe-co-allhomes-hero-photo-preview__gradient-hover.is-left{opacity:1;}}"
};
var _ref2 = {
  name: "1kqoftl",
  styles: "text-align:right;&:hover{.fe-co-allhomes-hero-photo-preview__gradient.is-right{opacity:0;}.fe-co-allhomes-hero-photo-preview__gradient-hover.is-right{opacity:1;}}"
};
export var navigation = _ref5 => {
  var _ref5$isLeft = _ref5.isLeft,
    isLeft = _ref5$isLeft === void 0 ? false : _ref5$isLeft,
    _ref5$isRight = _ref5.isRight,
    isRight = _ref5$isRight === void 0 ? false : _ref5$isRight;
  return /*#__PURE__*/css("height:216px;", media('>=tablet', '<desktop'), "{height:320px;}", media('>=desktop'), "{height:60vh;max-height:476px;}padding:0;width:", navButtonWidth, "px;z-index:1;border:0;cursor:pointer;background-color:transparent;&:focus{outline:none;}&:hover{.fe-co-allhomes-hero-photo-preview__navigation-icon{opacity:1;}}", isLeft && _ref, " ", isRight && _ref2);
};
var _ref3 = {
  name: "1t7utft",
  styles: "margin-left:18px;"
};
var _ref4 = {
  name: "x0sdsu",
  styles: "margin-right:18px;"
};
export var navigationIcon = _ref6 => {
  var _ref6$isLeft = _ref6.isLeft,
    isLeft = _ref6$isLeft === void 0 ? false : _ref6$isLeft,
    _ref6$isRight = _ref6.isRight,
    isRight = _ref6$isRight === void 0 ? false : _ref6$isRight;
  return /*#__PURE__*/css("width:42px;height:42px;stroke:", navigationArrowColour, ";stroke-width:4.2px;stroke-linecap:round;stroke-linejoin:round;fill:none;opacity:0.8;z-index:2;position:relative;transition:opacity 0.25s;", isLeft && _ref3, " ", isRight && _ref4);
};
export var gradient = _ref7 => {
  var _ref7$isLeft = _ref7.isLeft,
    isLeft = _ref7$isLeft === void 0 ? false : _ref7$isLeft,
    _ref7$isRight = _ref7.isRight,
    isRight = _ref7$isRight === void 0 ? false : _ref7$isRight;
  return /*#__PURE__*/css("position:absolute;top:0;width:", navButtonWidth, "px;height:100%;z-index:1;transition:opacity 0.25s;", isLeft && /*#__PURE__*/css("background:linear-gradient(to left,", gradientStart, ",", gradientEnd, ");"), " ", isRight && /*#__PURE__*/css("background:linear-gradient(to right,", gradientStart, ",", gradientEnd, ");"));
};
export var gradientHover = _ref8 => {
  var _ref8$isLeft = _ref8.isLeft,
    isLeft = _ref8$isLeft === void 0 ? false : _ref8$isLeft,
    _ref8$isRight = _ref8.isRight,
    isRight = _ref8$isRight === void 0 ? false : _ref8$isRight;
  return /*#__PURE__*/css(gradient({}), " opacity:0;", isLeft && /*#__PURE__*/css("background:linear-gradient( to left,", hoverGradientStart, ",", hoverGradientEnd, " );"), " ", isRight && /*#__PURE__*/css("background:linear-gradient( to right,", hoverGradientStart, ",", hoverGradientEnd, " );"));
};